<template>
  <div class="rg-video-playback-container-wrapper absolute">
    <div class="rg-video-playback-container flex flex-col">
      <div class="header flex justify-end items-center">
        <span
          class="close-btn"
          @click.stop.prevent="handleClickCloseButton"
        ></span>
      </div>
      <div class="body flex flex-col gap-3">
        <HlsVideoPlayer
          v-if="isVideoReady"
          ref="hlsVideoPlayer"
          :camera="playbackCamera"
          :start="start"
          :current="current"
          :end="end"
          :fps="fps"
          :isPause="isPause"
          :width="width"
        ></HlsVideoPlayer>
        <div
          class="camera-playback-list flex flex-row overflow-x-auto overflow-y-hidden"
        >
          <change-camera-playback-button
            v-for="{ id, name } in cameras"
            class="aisea-text-12-400-pure-white flex-shrink-0"
            :class="{ selected: id === playbackCameraId }"
            :key="id"
            :buttonText="name"
            :handleClick="() => handleClickCameraPlaybackListItem(id)"
          >
          </change-camera-playback-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HlsVideoPlayer from "./HlsVideoPlayer.vue";
import ChangeCameraPlaybackButton from "./ChangeCameraPlaybackButton.vue";
import mapKeys from "lodash/mapKeys";

export default {
  name: "HlsVideoPlayerContainer",
  components: {
    HlsVideoPlayer,
    ChangeCameraPlaybackButton,
  },
  props: {
    cameras: {
      type: Array, // Array<Camera>
      default() {
        return [];
      },
    },
    handleClickCameraPlaybackListItem: {
      type: Function,
      default: () => {},
    },
    handleClickCloseButton: {
      type: Function,
      default: () => {},
    },
    playbackCameraId: {
      type: String,
      default: "",
    },
    current: { type: Number, required: false },
    start: { type: Number, required: false },
    end: { type: Number, required: false },
    fps: { type: Number, required: false },
    isPause: { type: Boolean, required: false },
    width: {
      type: Number,
      default: 476,
    },
  },
  data() {
    return {
      isVideoPlayerInitialized: false,
    };
  },
  watch: {
    start(val) {
      if (val) {
        this.initializeVideoPlayer();
      }
    },
    playbackCameraId() {
      if (this.playbackCamera) {
        this.initializeVideoPlayer();
      }
    },
  },
  computed: {
    cameraMap() {
      return mapKeys(this.cameras, "id");
    },
    playbackCamera() {
      return this.cameraMap[this.playbackCameraId];
    },
    isVideoReady() {
      return this.isVideoPlayerInitialized && this.playbackCamera;
    },
  },
  methods: {
    setup() {
      this.initializeVideoPlayer();
    },
    async initializeVideoPlayer() {
      this.isVideoPlayerInitialized = false;
      await this.$nextTick();
      this.isVideoPlayerInitialized = true;
    },
  },
  mounted() {
    this.setup();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.rg-video-playback-container-wrapper {
  z-index: 1;
  --initial-top: 74px;
  --initial-right: 21px;

  top: var(--initial-top);
  right: var(--initial-right);
  .rg-video-playback-container {
    background-color: #021431;
    width: 500px;
    height: 333.47px;
    border-radius: 5px;
    padding: 6px 12px 10px 12px;
    .header {
      height: 22px;
      .close-btn {
        display: block;
        position: absolute;
        top: 2px;
        right: 8px;
        text-align: right;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #222222;
        cursor: pointer;
        user-select: none;

        &:hover {
          background-color: #333333;
          transition: background-color 0.3s ease;
          cursor: pointer;
        }
      }
    }
    .close-btn::before,
    .close-btn::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      height: 12px;
      background: #fff;
    }
    .close-btn::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    .close-btn::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
    .body {
      .camera-playback-list {
        gap: 8px;
      }
    }
  }
}
</style>
